// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2af707c6] .noWrap {\n  white-space: nowrap;\n}\n[data-v-2af707c6] .compact-control {\n  padding-bottom: 0px;\n  padding-top: 0px;\n  padding-left: 2px;\n  height: 1.5rem;\n  width: 150px;\n  font-size: 12px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
